// extracted by mini-css-extract-plugin
export var backgroundShapes = "BackgroundShapes-module--backgroundShapes--DjdGr";
export var children = "BackgroundShapes-module--children--efTXc";
export var hideLtDesktop = "BackgroundShapes-module--hideLtDesktop--UHrjb";
export var limitWidthOnLargeScreens = "BackgroundShapes-module--limitWidthOnLargeScreens--6EnDw";
export var wrapper = "BackgroundShapes-module--wrapper--hc5Mn";